<template>
  <div class="bg_fff searchFilter f_14 pr" :style="{paddingLeft: isSearchIndex ? 0 : '32px'}" :class="[position==='header'? 'headerPosition' : '']">

    <div class="toggleFilter transition_2" :class="[(position==='header'&& showHeaderFilter || position!=='header') || isSearchIndex ? 'showFilter' : '']">
      <div class="filterItem flex">
        <div class="title color_40"><span>城市</span><i>（单选）</i>：</div>
        <div data-growing-container data-growing-idx="100" class="filter flex1 clearfix">
          <div :class="['item fl cursor_p color_a0_hover', activeRadio('selectedCity',item.city_name)?'color_blue':'' ]" v-for="item in hot_cities" :key="item.id" @click="selectCityFunc(item.city_name)">{{item.city_name}}</div>
          <div :class="{'color_blue': activeMoreCity()}" class="item fl cursor_p color_a0_hover" @click="showCityDialog()">更多城市</div>

        </div>
      </div>
      <div class="filterItem flex">
        <div class="title color_40"><span>学历</span><i>（多选）</i>：</div>
        <div data-growing-container data-growing-idx="200" class="filter flex1 clearfix">
          <div :class="['item fl cursor_p color_a0_hover', activeItem('selectedEducation',item)?'color_blue':'' ]" v-for="item in selectData.education" :key="item" @click="checkFilter('selectedEducation',item)">{{item}}</div>
        </div>
      </div>
      <div class="filterItem flex">
        <div class="title color_40"><span>院校</span><i>（多选）</i>：</div>
        <div data-growing-container data-growing-idx="300" class="filter flex1 clearfix">
          <div :class="['item fl cursor_p color_a0_hover', activeItem('selectedSchool',item)?'color_blue':'' ]" v-for="item in selectData.school" :key="item" @click="checkFilter('selectedSchool',item)">{{item}}</div>
        </div>
      </div>
      <div class="filterItem flex">
        <div class="title color_40"><span>工作经验</span><i>（多选）</i>：</div>
        <div data-growing-container data-growing-idx="400" class="filter flex1 clearfix">
          <div :class="['item fl cursor_p color_a0_hover', activeItem('selectedeXperience',item)?'color_blue':'' ]" v-for="item in selectData.xperience" :key="item" @click="checkFilter('selectedeXperience',item)">{{item}}</div>
        </div>
      </div>
    </div>

    <div class="filterItem flex" style="padding-top: 6px;" v-if="!isSearchIndex">
      <div class="title color_40"><span>您已选择</span>：</div>
      <div class="checkBox flex1 clearfix">
        <template v-if="selectedCity && selectedCity != '全国'">
          <div class="item fl cursor_p color_blue">{{selectedCity}}<span class="iconfont iconquxiao cursor_p font_w_b" @click="deleteCityFunc"></span></div>
        </template>
        <div class="item fl cursor_p color_cf" v-else>全国</div>

        <template v-if="selectedEducation.length">
          <div class="item fl cursor_p color_blue" v-for="item in selectedEducation" :key="item">{{item}}<span class="iconfont iconquxiao cursor_p font_w_b" @click="checkFilter('selectedEducation',item)"></span></div>
        </template>
        <div class="item fl cursor_p color_cf" v-else>学历不限</div>

        <template v-if="selectedSchool.length">
          <div class="item fl cursor_p color_blue" v-for="item in selectedSchool" :key="item">{{item}}<span class="iconfont iconquxiao cursor_p font_w_b" @click="checkFilter('selectedSchool',item)"></span></div>
        </template>
        <div class="item fl cursor_p color_cf" v-else>院校不限</div>

        <template v-if="selectedeXperience.length">
          <div class="item fl cursor_p color_blue" v-for="item in selectedeXperience" :key="item">{{item}}<span class="iconfont iconquxiao cursor_p font_w_b" @click="checkFilter('selectedeXperience',item)"></span></div>
        </template>
        <div class="item fl cursor_p color_cf" v-else>经验不限</div>

        <div class="reset cursor_p fr color_9c" @click="( (selectedCity && selectedCity != '全国') ||selectedEducation.length || selectedSchool.length || selectedeXperience.length) ? $emit('resetFilter') : null" v-if="position==='header' ? showHeaderFilter : true" >重置</div>
      </div>
    </div>

    <div class="toggleButton el-icon pa el-icon-arrow-up color_9c cursor_p" :class="[showHeaderFilter?'active':'']" v-if="position" @click="showHeaderFilter = !showHeaderFilter"></div>

    <city-block :show="cityDialogVisible"
                :activeCity="selectedCity"
                @clickFunc="clickFunc"
                @closeFunc="closeFunc" />

  </div>
</template>

<script>
// 所有接口
import actions from '@/actions/index'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getCookieValue, get_tUser, toLogin } from '@/utils/utils'
import { Base64 } from 'js-base64';
import cityBlock from '@/components/block/CityBlock'

import searchConfig from '@/mixins/search/config'

export default {
  name: 'searchFilter',
  mixins:[searchConfig],
  props:{
    position:{ },
    'selectedCity':{ //学历选中数据
      type:String,
      default: '',
    },
    'selectedEducation':{ //学历选中数据
      type:Array,
      default:()=>[],
    },
    'selectedSchool':{ //学校选中数据
      type:Array,
      default:()=>[],
    },
    'selectedeXperience':{ //经验选中数据
      type:Array,
      default:()=>[],
    },
    'latest':{
      type:Number,
      default:0,
    },
    scrollHeaderHeight:{
      type:Number,
      default:0,
    },
    isSearchIndex: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      userJWT:{}, //当前用户的一些jwt信息
      jobType:{
        '大专':'专科,本科,硕士,博士,MBA',
        '专科':'专科,本科,硕士,博士,MBA',
        '本科':'本科,硕士,博士,MBA',
        '硕士':'硕士,博士,MBA',
        '博士':'博士,MBA',
        'MBA':'MBA',
      },
      showHeaderFilter: false, //是否显示顶部筛选
      cityDialogVisible: false // 显示选择城市弹窗
    }
  },
  created(){

  },
  components: {
    cityBlock
  },
  computed:{
    ...mapState('block',['userInfoState']),
    ...mapState('resumeDetails',['myPosition']),
  },
  methods:{
    ...mapMutations('resumeDetails',['updateMyPosition']),
    ...mapActions('resumeDetails',['getMyPosition']),

    //点击查看最新简历
    checkLatest(){
      this.$emit('checkLatest')
    },
    //判断学历,院校，工作经验 是否高亮
    activeItem(type, item){
      if(item==='不限' && !this[type].length){
        return true
      }
      let active = false;
      this[type].forEach(sitem=>{
        if(sitem === item){
          active = true
        }
      })
      return active
    },
    activeRadio (type, item) {
      if (item === '全国' && !this[type]) return true
      if (item === this[type]) return true
    },
    activeMoreCity () {
      let active = true
      this.hot_cities.forEach(item => {
        if (item.city_name === this.selectedCity) {
          active = false
        }
      })
      return active
    },
    deleteCityFunc () {
      this.$emit('deleteCityFunc')
    },
    // 单选
    selectCityFunc (data) {
      // flag: true选择 false取消
      this.$emit('selectCityFunc', data)
    },
    //点击筛选项
    checkFilter(type, item){
      this.$emit('checkFilter',{type,item})
    },
    // 显示选择城市弹窗
    showCityDialog () {
      this.cityDialogVisible = true
    },
    clickFunc (data) {
      this.selectCityFunc(data.city_name)
      this.cityDialogVisible = false
    },
    closeFunc () {
      this.cityDialogVisible = false
    }
  },
}
</script>
<style lang="scss" scoped>
  @import './searchFilter2.scss';
</style>